import { ScreeningReport } from "@/core/customers/entities/CustomerAnalysis";
import { Account } from "@/core/customers/entities/Accounts";
import GetScreeningReportsUseCase from "@/core/customers/useCases/GetScreeningReportsUseCase/GetScreeningReportsUseCase";
import GetAccountsOverviewUseCase from "@/core/customers/useCases/GetAccountsOverviewUseCase/GetAccountsOverviewUseCase";
import type { FicheClient360State, FicheClient360StoreDeps } from "../types";
import { createFetchAction } from "../helpers";

export function createSyntheseSlice(
  deps: FicheClient360StoreDeps,
  set: (partial: Partial<FicheClient360State>) => void,
): Partial<FicheClient360State> {
  const getScreeningReportsUseCase = new GetScreeningReportsUseCase(
    deps.screeningReportsRepository,
  );
  const getAccountsOverviewUseCase = new GetAccountsOverviewUseCase(
    deps.accountsRepository,
  );

  return {
    fetchScreeningReports: createFetchAction<ScreeningReport[]>(
      set,
      "screeningReportsLoading",
      "screeningReportsError",
      "screeningReports",
      (businessKey) => getScreeningReportsUseCase.execute(businessKey),
      "Erreur lors du chargement des rapports de screening :",
      () => [],
    ),

    fetchAccountsOverview: createFetchAction<Account[]>(
      set,
      "accountsOverviewLoading",
      "accountsOverviewError",
      "accountsOverview",
      (businessKey) => getAccountsOverviewUseCase.execute(businessKey),
      "Erreur lors du chargement de l'aperçu des comptes :",
      () => [],
    ),
  };
}
